"use strict";

exports.__esModule = true;
exports["default"] = exports.MappedSlideIn = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = require("ramda");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _animations = require("@qc-modules/animations");

var _propTypes = require("prop-types");

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _growler = _interopRequireDefault(require("./growler"));

var _excluded = ["children", "in"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  delayIn: _propTypes.number,
  delayOut: _propTypes.number,
  // Array of results to display
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    buttons: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string,
      title: _propTypes.string,
      url: _propTypes.string
    })),
    desc: _propTypes.string,
    id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
    title: _propTypes.string.isRequired
  })),
  // Function triggered when closing the growler
  onCloseClick: _propTypes.func.isRequired
};
var SlideInPropTypes = {
  children: _propTypes.node,
  "in": _propTypes.bool
};
var Container = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "growler__Container",
  componentId: "sc-qz32yv-0"
})(["position:fixed;bottom:0;right:0;"]); // Renames prop set by TransitionGroup to fix reserved word (in) bug

var MappedSlideIn = function MappedSlideIn(_ref) {
  var children = _ref.children,
      show = _ref["in"],
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_animations.SlideIn, _extends({}, props, {
    show: show
  }), children);
};

exports.MappedSlideIn = MappedSlideIn;
MappedSlideIn.propTypes = SlideInPropTypes;

var GrowlerContainer = function GrowlerContainer(_ref2) {
  var _ref2$delayIn = _ref2.delayIn,
      delayIn = _ref2$delayIn === void 0 ? 0 : _ref2$delayIn,
      _ref2$delayOut = _ref2.delayOut,
      delayOut = _ref2$delayOut === void 0 ? 0 : _ref2$delayOut,
      onCloseClick = _ref2.onCloseClick,
      items = _ref2.items;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    alignItems: "flex-end",
    flexDirection: "column-reverse",
    height: 0,
    width: [1, 0]
  }, /*#__PURE__*/_react["default"].createElement(_animations.TransitionGroup, {
    component: null
  }, (0, _ramda.is)(Array, items) ? (0, _utils.mapIndexed)(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(MappedSlideIn, {
      key: item.id || item.title + ":" + index,
      alwaysShowInDom: false,
      delayIn: delayIn + 0.25 * index,
      delayOut: delayOut + 0.25 * index,
      enterDuration: 0.7,
      exitDuration: 0.7,
      horizontal: 1.2,
      vertical: 0
    }, /*#__PURE__*/_react["default"].createElement(_growler["default"], _extends({
      isFirst: index === 0,
      onCloseClick: onCloseClick
    }, item)));
  }, items) : null));
};

GrowlerContainer.propTypes = propTypes;
GrowlerContainer.displayName = "Modules.GrowlerContainer";
var _default = GrowlerContainer;
exports["default"] = _default;